module.exports = __webpack_public_path__ + "img/jifen9.20fa98ee.png";